import { ComponentFactoryResolver, Injectable, Injector, ReflectiveInjector, Type, ViewContainerRef } from '@angular/core';
import { ModalComponent } from 'app/components/modal/modal.component';

@Injectable()
export class ModalService {

    private viewContainerRef: ViewContainerRef;

    private currentComponent;

    constructor(private resolver: ComponentFactoryResolver) { }

    public async open<T extends ModalComponent<TResult>, TResult>(componentType: Type<T>, parameters?: any): Promise<TResult> {

        let componentFactory = this.resolver.resolveComponentFactory(componentType);

        // Create the component with the specified inputs
        let component = this.viewContainerRef.createComponent(componentFactory);
        this.currentComponent = component;

        Object.assign(component.instance, parameters);

        // Open the modal
        let result = await component.instance.open();

        // Return the modal promise
        return result;
    }

    public registerViewContainerRef(viewContainerRef: ViewContainerRef): void {
        this.viewContainerRef = viewContainerRef;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/modal.service.ts